import $ from 'jquery';

$(function () {

    $(document).on(
        'click',
        'button[data-collection-add]',
        function () {
            let template = $(this).parent().prev().children('span').data('template');

            if (typeof template === 'undefined') {
                template = $(this).parent().prev().children('fieldset').children('span').data('template');
            }
            if (typeof template === 'undefined') {
                return false;
            }

            let placeholder = $(this).data('template-placeholder') || '__index__';

            let regex = new RegExp(placeholder, 'g');
            template = template.replace(regex, Math.round(new Date().getTime() + (Math.random() * 100)));

            $(this).parent().prev().append(template);

            $(this).parent().prev().find('.select2-selection').each(function () {
                sortSelectOptions($(this));

                $(this).select2();
            });

            return false;
        }
    );

    $(document).on(
        'click',
        'button[data-collection-remove]',
        function (event) {
            $(event.currentTarget).closest('fieldset').remove();
            return false;
        }
    );

    function sortSelectOptions($selectField) {
        // All options of the current select field
        let options = $selectField.children();
        // The beforehand selected option.
        let selectedOption = $selectField.val();
        // The empty option. Important to initialize as we need it later on.
        let emptyOption = {};

        // The actual sorting of all options, including the empty option.
        options.sort(function (a, b) {
            // If an option don't hold any value, we know it's our empty option. We want to store this to a new let
            // to later on be able to prepend it to our select.
            if ($(a).val() === '') {
                emptyOption = a;
            }

            // Sorting.
            if (a.text > b.text) {
                return 1;
            } else if (a.text < b.text) {
                return -1;
            } else {
                return 0;
            }
        });

        // Writing the options back to the current select after we empty it.
        $selectField.empty().append(options);

        // Set the select value to our selected option.
        $selectField.val(selectedOption);
        // Prepend the empty option to the beginning of the current selects options list.
        $selectField.prepend(emptyOption);
    }

    // please sort away

    let navbar = document.querySelector('.login_box');
    if (document.getElementById("navbar-toggler") != null) {
        document.getElementById("navbar-toggler").addEventListener("click", function () {
            navbar.classList.toggle('in');
        });
    }

});
